<template>

	<div id="js-product-list" class="g-searchspring__listing g-product-list">
		<div v-if="pagination.totalResults > 0" class="g-layout u-grids-2 u-grids-3--m u-grids-4--l u-grids-5--xxxl g-product-list--searchspring">
			<template v-for="(result, index) in results">
				<inline-banner v-if="result.isInlineBanner" :key="index" :result="result" />
				<product-card v-else :key="index" :result="result"></product-card>
			</template>
		</div>

		<div v-if="pagination.totalResults === 0">
			<div class="u-text-center">
				<br>
				<span class="g-heading-style-5 u-font-weight--semibold">No Results.</span>
				<br>
			</div>
		</div>
	</div>

</template>



<script>
	import InlineBanner from './InlineBanner';
	import ProductCard from './ProductCard';

	export default {
		props: {
			results: {
				default() {
					return {};
				}
			},
			pagination: {
				default() {
					return {};
				}
			},
			merchandising: {
				default() {
					return {};
				}
			}
		},
		components: {
			'inline-banner': InlineBanner,
			'product-card': ProductCard
		},

		mounted() {
			if(this.results.length > 0)
			{
				const el = document.getElementById('js-product-list');
				const script = document.createElement('script');

				// Build LD+JSON from results
				let ldJson = [];
				for (const product of this.results) {
					if(!product.isInlineBanner) {
						ldJson.push(this.buildProductJSON(product));
					}
				}
				script.type = 'application/ld+json';
				script.text = JSON.stringify(ldJson);
				el.appendChild(script);
			}
		},
		methods: {
			buildProductJSON(product) {
				const brand = product.brand || '';
				const baseURL = mivaJS.Storefront_Url.replace(/\/+$/, '');

				// if relative URL add baseURL
				if (product.url.indexOf('http://') !== 0 && product.url.indexOf('https://') !== 0) {
					product.url = baseURL + product.url;
				}

				const productJSON = `
					{
						"@context": "https://schema.org",
						"@type": "Product",
						"@id": "${product.url}",
						"brand": "${brand}",
						"image": [
							"${product.image}?tx=c_pad,b_white,ar_1:1",
							"${product.image}?tx=c_pad,b_white,ar_4:3",
							"${product.image}?tx=c_pad,b_white,ar_16:9"
						],
						"sku": "${product.ss_sku}",
						"itemCondition": "https://schema.org/NewCondition",
						"name": "${product.name}",
						"offers": [
							{
								"@type": "Offer",
								"itemCondition": "https://schema.org/NewCondition",
								"availability": "https://schema.org/InStock",
								"priceCurrency": "USD",
								"price": "${product.price}",
								"url": "${product.url}"
							}
						],
						"productID": "${product.ss_sku}",
						"url": "${product.url}"
					}
					`;
				return JSON.parse(productJSON);
			}
		}
	}

</script>
